module.exports = __webpack_public_path__ + "components/flag/static/square/tg-8cd3d5a189c6158bded9964b25af9d65.svg";